<template>
  <detail-layout-two-columns-no-fixed>
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
      </div>
    </template>
    <template slot="LeftCol">
      <div class="form-wrapper px-4 lg:px-10">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full md:w-11.5/12 lg:max-w-detailinvoice"
          autocomplete="off"
        >
          <div class="flex-1">

            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">       
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('invoices.num_factura') }}</label>
                <el-form-item prop="numFactura">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.numFactura"
                    maxlength='20'
                  />
                </el-form-item>
              </div>
              <div class="w-full" >
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.serie_factura') }}</label>
                <el-form-item prop="serieFactura" class="w-full">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.serieFactura"
                    maxlength='20'
                  />
                </el-form-item>
              </div>
            </div>

            <div class="lg:mb-2">
              <div >
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('app.date') }}</label>
                <el-form-item prop="dateEmision">
                  <el-date-picker v-model="form.dateEmision" type="date" :picker-options="dateRangeOptions"
                    :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" :placeholder="$d(Date.now(), 'numeric_date', { date: '-' })"></el-date-picker>
                </el-form-item>
              </div>
            </div>

            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.num_albaran') }}</label>
                  <el-form-item prop="albaran">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.albaran"
                      maxlength='30'
                    />
                  </el-form-item>
              </div>

              <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.step2.numero_pedido') }}</label>
                  <el-form-item prop="pedido">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.pedido"
                      maxlength='20'
                    />
                  </el-form-item>
              </div>
            </div>

            <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.observaciones') }}</label>
                <el-form-item prop="observaciones">
                  <el-input type="textarea" :rows="3" clearable class="w-full"
                    v-model="form.observaciones" maxlength="2500" />
                </el-form-item>
            </div>

            <!-- IRPF, Suplidos y Fechas de Facturación -->
            <step-3-others ref="embedded-step" class="embedded-step" :is-first-step="isFirstStep" :step="{}" v-model="value" />

            <base-collapsible-form ref="baseCollapsible" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('invoices.invoices_issuing.contracting_and_order_data') }}</h4>
              </template>
              <template slot="content">
                <base-ro-input-inline class="mb-2 text-sm" :label="$t('invoices.invoices_issuing.expediente')" />
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.numero') }}</label>
                    <el-form-item prop="numExpediente">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.numExpediente"
                        maxlength='20'
                        @change="value => validateFields('dateExpediente', value)"
                        @clear="() => validateFields('dateExpediente')"
                      />
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.date') }}</label>
                    <el-form-item prop="dateExpediente">
                      <el-date-picker v-model="form.dateExpediente" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern" :picker-options="dateRangeOptions" @change="value => validateFields(value, 'numExpediente')"></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
                
                <base-ro-input-inline class="mb-2 text-sm" :label="$t('invoices.invoices_issuing.pedido_emisor')" />
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.numero') }}</label>
                    <el-form-item prop="numEmisor">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.numEmisor"
                        maxlength='20'
                        @change="value => validateFields('dateExpediente', value)"
                        @clear="() => validateFields('dateExpediente')"
                      />
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.date') }}</label>
                    <el-form-item prop="dateEmisor">
                      <el-date-picker v-model="form.dateEmisor" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern" :picker-options="dateRangeOptions" @change="value => validateFields(value, 'dateExpediente')"></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
                
                <base-ro-input-inline class="mb-2 text-sm" :label="$t('invoices.invoices_issuing.contrato')" />
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.cod_asignacion_receptor') }}</label>
                    <el-form-item prop="codAsignacion">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.codAsignacion"
                        maxlength='20'
                        @change="value => validateFields('dateReceptor', value)"
                        @clear="() => validateFields('dateReceptor')"
                      />
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.date') }}</label>
                    <el-form-item prop="dateReceptor">
                      <el-date-picker v-model="form.dateReceptor" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern" :picker-options="dateRangeOptions" @change="value => validateFields(value, 'codAsignacion')"></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
                
                <!-- v-if="faceb2b" -->
                <base-ro-input-inline class="mb-2 text-sm" :label="$t('invoices.invoices_issuing.licitacion')" />
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.dir3_licitacion') }}</label>
                    <el-form-item prop="dir3">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.dir3"
                        maxlength='20'
                        @change="value => validateFields('numContrato', value)"
                        @clear="() => validateFields('numContrato')"
                      />
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.num_contrato') }}</label>
                    <el-form-item prop="numContrato">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.numContrato"
                        maxlength='20'
                        @change="value => validateFields('dir3', value)"
                        @clear="() => validateFields('dir3')"
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="lg:mb-2">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.cod_dep_receptor') }}</label>
                  <el-form-item prop="codDepReceptor">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.codDepReceptor"
                      maxlength='20'
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>

          </div>
        </el-form>
      </div>
    </template>
    <template slot='RightCol'>
      <slot name="invoice-summary" />
    </template>
    <template slot='layout-extend'>
      <slot name="layout-extend" :valid="isValid" />
    </template>
  </detail-layout-two-columns-no-fixed>
</template>

<script>
import DetailLayoutTwoColumnsNoFixed from '@/components/layout/DetailLayoutTwoColumnsNoFixed.vue'
import Step3Others from '@/views/invoices/issuingSteps/Step3Others.vue'
import { i18n } from '@/i18n'
// import UserGeneratePasswordDialog from '@/components/UserGeneratePasswordDialog.vue'
import { getNextInvoiceDefault } from '@/services/configurations/getNextInvoiceDefault'
import { checkInvoiceNumber } from '@/services/configurations/checkInvoiceNumber'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import moment from 'moment'

export default {
  /* eslint-disable camelcase */
  name: 'step2-detail',
  components: {
    DetailLayoutTwoColumnsNoFixed,
    Step3Others,
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      localValue: this.value,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      distribuidores: [],
      loadingDistribuidores: false,
      loadingClientes: false,
      loadedFirstTime: false,
      vuexnamespace: 'invoicesIssuing/2',
      clientes: [],
      isSeriePropuesta: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
        // disabledDate: this.disabledFutureDates
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rules: {
        numFactura: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        dateEmision: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        numExpediente: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.numExpediente && this.form.dateExpediente) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        dateExpediente: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.numExpediente && !this.form.dateExpediente) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        numEmisor: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.numEmisor && this.form.dateEmisor) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        dateEmisor: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.numEmisor && !this.form.dateEmisor) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        codAsignacion: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.codAsignacion && this.form.dateReceptor) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        dateReceptor: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.codAsignacion && !this.form.dateReceptor) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        dir3: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.dir3 && this.form.numContrato) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        numContrato: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.dir3 && !this.form.numContrato) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
      },
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    getInvoiceNumber: function () {
      return this.$store.getters['invoicesIssuing/form'].numFactura
    },
    getSerialNumber: function () {
      return this.$store.getters['invoicesIssuing/form'].serieFactura
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isValid: function () {
      return this.form.numFactura !== '' && this.form.dateEmision !== null && this.form.dateEmision !== ''
    },
    idCIFEmpresa: function () {
      return this.$store.getters['invoicesIssuing/form']?.issuer?.IdCIFEmpresa || ''
    }
  },
  async mounted () {
    await this.getInvoiceSerialNumber(this.idCIFEmpresa || -1)

    if (!this.form.dateEmision) {
      this.form.dateEmision = moment().format('yyyy-MM-DD[T00:00:00]')
    }
  },
  watch: {
    value: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    },
    localValue: function (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('input', value)
      }
    },
    'form.serieFactura': function (value, oldValue) {
      if (value !== oldValue && this.isSeriePropuesta) {
        this.form.numFactura = ''
        this.isSeriePropuesta = false
      }
    }
  },
  methods: {
    disabledFutureDates (date) {
      const today = moment().startOf('day')
      const selected = moment(date).startOf('day')
      return selected.isAfter(today)
    },
    validate: function (callback = (valid) => {}) {
      this.$refs.ruleForm.validate(valid => {
        this.$refs['embedded-step'].validate(async valid2 => {
          const params = {
            idCliente: this.value || null,
            idCIFEmpresa: this.idCIFEmpresa || null,
            serieFactura: this.form.serieFactura || null,
            numeroFactura: this.form.numFactura || null,
            fechaFactura: this.form.dateEmision || null
          }
          if (valid && valid2) {
            try {
              const data = await checkInvoiceNumber(params)
              if (data.blnError) {
                this.doFeedback(`${data.msgError} [${data.codError}]`)
                callback(new Error(`${data.msgError} [${data.codError}]`))
              } else {
                callback(data.Respuesta, i18n.t('feedback.error.duplicated_invoicenumber_error'))
              }
            } catch {
              this.doFeedback(i18n.t('feedback.error.general'))
              callback(new Error(i18n.t('feedback.error.general')))
            }
          } else {
            callback(new Error())
          }
        })
      })
    },
    resetForm () {
      this.$store.dispatch(this.vuexnamespace + '/resetForm')
      this.$refs['embedded-step'].resetForm()
    },
    validateFields (fields = [], value = '') {
      this.$refs.ruleForm.validateField(fields)
    },
    getInvoiceSerialNumber: async function (id) {
      if (this.getInvoiceNumber === '' && this.getSerialNumber === '') {
        const params = { idCIFEmpresa: id }
        const data = await getNextInvoiceDefault(params)
        if (data.blnError === true) {
          data.codError !== 'GNID003' ? this.doFeedback(`${data.msgError} [${data.codError}]`) : this.doFeedback(i18n.t('invoices.invoices_issuing.step2.warning_num_factura'), 'warning')
        }
        this.form.numFactura = data.respuesta?.InvoiceNumber || ''
        this.form.serieFactura = data.respuesta?.SerialNumber || ''
        this.$nextTick(() => { if (this.form.serieFactura !== '') { this.isSeriePropuesta = true } })
      }
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
.embedded-step::v-deep .lg\:max-w-detail > div {
  padding: 0;
}
</style>
